document.addEventListener('DOMContentLoaded', () => {
    // Abrir: cualquier trigger con data-dialog-target="#id-del-dialog"
    document.querySelectorAll('[data-dialog-target]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const selector = trigger.getAttribute('data-dialog-target');
            const dialog = document.querySelector(selector);
            if (!dialog) return;

            dialog.showModal();
            dialog.dispatchEvent(new CustomEvent('dialog:open'));
        });
    });

    // Cerrar: botón interno con data-dialog-close
    document.querySelectorAll('[data-dialog-close]').forEach((btn) => {
        btn.addEventListener('click', () => {
            btn.closest('dialog')?.close();
        });
    });

    // Cerrar al hacer click en el backdrop (afuera del contenido)
    document.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', (e) => {
            if (e.target === dialog) {
                dialog.close();
            }
        });

        // Punto de enganche si necesitás re-inicializar un carousel al abrir
        dialog.addEventListener('dialog:open', () => {
            // ej: if (window.Splide) new Splide(dialog.querySelector('.splide')).mount();
        });
    });

    document.querySelectorAll('.modal-floors__selector').forEach((selector) => {
        selector.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-floor-tab]');
            if (!btn) return;

            const targetId = btn.getAttribute('data-floor-tab');
            const gallery = selector.closest('.modal-floors__gallery-content');

            // Desactivar todos los tabs y paneles de esta galería
            gallery.querySelectorAll('.modal-floors__selector-btn').forEach((b) => {
                b.classList.remove('modal-floors__selector-btn--active');
                b.setAttribute('aria-selected', 'false');
            });
            gallery.querySelectorAll('.modal-floors__image').forEach((img) => {
                img.classList.remove('modal-floors__image--active');
            });

            // Activar el seleccionado
            btn.classList.add('modal-floors__selector-btn--active');
            btn.setAttribute('aria-selected', 'true');
            document.getElementById(targetId)?.classList.add('modal-floors__image--active');
        });
    });
});
